<template>
    <v-container grid-list-sm class="pt-3 pb-0 pl-50 pr-50">
        <v-layout row wrap elaine>
        <v-flex xs12 sm5 md6 lg6 hans>
        {{ title }}
            <v-flex xs3 sm5 md5 lg12 zaza class="pt-0 pb-0 pl-0 pr-0">
                    <v-combobox
                        v-model="selectMaterial"
                        :items="materialData"
                        label="Select a Type"
                    ></v-combobox>
            </v-flex>
            <v-flex xs3 sm5 md5 lg12 zaza class="pt-0 pb-0 pl-0 pr-0">
                    <v-combobox
                        v-model="selectDivision"
                        :items="items"
                        label="Select a division"
                    ></v-combobox> 
            </v-flex>
                    <v-flex xs3>
                    <v-btn v-on:click="getMat">Material TEST</v-btn>
                    </v-flex>
                    <v-flex xs6>
                    <v-select
                        v-model="selectMat"
                        :items="matData"
                        item-text= "CN_DESC"
                        item-value="CN_REF"                                                
                        @change="onMaterialChange"        
                        label="Select"
                        single-line
                        bottom
                    ></v-select>                    
                    <v-flex xs12 sm12 md12>
                    <v-text-field
                        label="Price"
                        value="CN_COST"
                        solo
                    ></v-text-field>
                    </v-flex>
                    <v-flex xs3 offset-xs1>
                        Selected value is {{ this.matData.CN_COST || "null" }}
                    </v-flex>                    
                    </v-flex>
         </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'StripCalculator',
    data() {
        return {
            title: 'Strip Calculator jjm',
            isBusy: false,
            selectMaterial: 'Strip',
            materialData: [
                'Strip',
                'Frame'
            ],
            selectDivision: 'Rubber',
            items: [
                'Rubber',
                'Sponge',
                'IGM',
                'Metal'
            ],
            selectMat: '',
            // No used
            cstMat: '',
            matData: []
        };
    },
    mounted() {
        this.selectedCustomer = this.ContextCustomer || {};
    },
    methods: {
        getMat() {
            this.$http
                .post('/jmpcontroller/postname', { myref: this.selectDivision })
                .then(response => {
                    console.warn(response.data);
                    this.matData = null;
                    this.matData = response.data;
                    // alert(this.matData);
                    // matData = response.data;
                    /*
                    if (response.data.s) {
                        const d = [];
                        response.data.d.forEach(o => {
                            d.push(o._id);
                        });
                        this.rateData = d;
                        this.rating = d[1];
                    }
                    else {
                        this.$alert({ type: 'error', title: 'Data call failed', message: `${response.data.m}` });
                    }
                    */
                })
                .catch(error => {
                    this.$alert({ type: 'error', title: 'Data call failed', message: `${error}` });
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        onMaterialChange() {
            // this.$router.push({ path: a.src });
            // this.selectMat.CN_COST = this.selectMat.CN_COST;
            // alert(this.selectMat.CN_COST);
            // var cost = 0.00;
            // cstMat = this.selectMat.CN_COST/10000;
            // console.log(this.selectMat.CN_COST/10000);
            // console.log(cost);
            // console.log(a, this.select.src);
            // return cost;
        }
    }
};
</script>

<style scoped>
    .hans{
        background-color: lightcyan;
    }
    .sibo{
        background-color :bisque;
    }
    .elaine{
        background-color :rgb(233, 243, 248)
    }
        .zaza{
        background-color :khaki;
    }
</style>


// WEBPACK FOOTER //
// src/components/PriceList/StripCalculator.vue